<!-- Beginning of the left draw -->
<template v-slot:default="{ on, attrs }">  
    <v-card>
        <v-navigation-drawer
            app
            v-model="drawer"
            color="white"
            permanent
        >
        <!--
            :mini-variant.sync="mini"
            bottom
            temporary   
            absolute
            <v-icon @click.stop="mini = !mini" class="pa-0">mdi-chevron-left</v-icon>
        -->
        <v-list-item class="pt-2">
            <v-img width="50" height="30" src="../assets/trianglelogo.png"></v-img>
            <v-list-item-subtitle 
                class="
                text-xs-h6         
                text-sm-h5         
                text-md-h5          
                text-lg-h4      
                text-xl-h4
                font-weight-bold">Triyangle.</v-list-item-subtitle>
        </v-list-item>
        <v-divider class="mr-4 ml-3"></v-divider>
        <v-list 
            nav
            dense
        >
        <v-dialog
            v-model="dialog"
            width="1024"
        >
            <template v-slot:activator="{ on, props }">
                <v-list-item-title class="px-5 font-weight-normal">Job Position Available
                    <v-btn
                        v-bind="props"
                        v-on="on"
                        color="grey"
                        icon="true"
                        @click="toggleJobForm"
                        ><v-icon>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                </v-list-item-title>
            </template>
            <v-card>
                <jobPosition @handle-toggle-form="toggleJobForm" @fetch-job-positions="getJobPositions"/>
            </v-card>
        </v-dialog>
             <!-- List item begins here -->
            <v-list-item
                v-for="item in items"
                :key="item.title"
                link
                color="white"
            >
                <v-row dense>
                    <v-col>
                        <v-list 
                            class="pl-2"
                            dense>
                            <v-card>
                                <v-list-item class="px-0 text-caption">
                                    <v-expansion-panels>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header class="pr-1">
                                                <v-img :src="item.company_logo" max-width="25" contain alt="company logo"></v-img>
                                                <v-list-item-title class="pl-1">{{ item.title }}</v-list-item-title>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                {{ truncateDescription(item.description, 100) }}
                                                <v-divider width="60" class="mt-4 ml-3"></v-divider>
                                                <v-card-actions>
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-model="sheet"
                                                        v-on="on"
                                                        color="blue"
                                                        x-small
                                                        text
                                                        right
                                                    >
                                                    <a :href="''+ item.website_link" target="_blank">View More</a>
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-list-item>
                            </v-card>
                        </v-list>
                    </v-col>
                </v-row>
            </v-list-item>
            <div class="bottom-div pl-0">
            <v-divider class="mt-4 ml-3"></v-divider>
                <v-list-item-title class="pl-4 font-weight-normal">Project Progress</v-list-item-title>
                <!-- Secong left draw -->
                <v-list-item
                    v-for="items in items2"
                    :key="items.title"
                    link
                    color="white"
                >
                    <v-row dense>
                        <v-col>
                            <v-list
                                class="pl-2 text-caption"
                                color="white"
                                dense>
                                <v-list-item class="px-0">
                                    <v-expansion-panels>
                                        <v-expansion-panel>
                                            <v-expansion-panel-header>
                                                <v-icon size="20" class="px-2" color="blue">{{ items.icon }}</v-icon>
                                                <v-list-item-title>{{ items.title }}</v-list-item-title>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                Lorem ipsum dolor sit amet, consectetur 
                                                adipiscing elit, sed do eiusmod tempor 
                                                incididunt ut labore et dolore magna....
                                                <v-divider width="60" class="ml-3"></v-divider>
                                                <div>
                                                    <v-slider
                                                    thumb-icon="$"  
                                                    thumb-label="always"
                                                    >
                                                    </v-slider>
                                                </div>
                                                <v-card-actions>
                                                    <v-bottom-sheet width="1200px" inset v-model="sheet">
                                                        <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            v-bind="attrs"
                                                            v-model="sheet"
                                                            v-on="on"
                                                            color="blue"
                                                            @click="toggleProfilePage"
                                                            x-small
                                                            text
                                                            right
                                                        >
                                                            View More
                                                        </v-btn>
                                                        </template>
                                                        <profilePage v-if="showProfilePage"/>
                                                        <!--End of profile page-->
                                                    </v-bottom-sheet>
                                                </v-card-actions>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-list-item>
            </div>
            <!--Ending of second left draw-->
        </v-list>
        </v-navigation-drawer>
    </v-card>
</template>
<!-- End of the left draw -->

<script>
import axios from 'axios'
import profilePage from './profilePage'
import jobPosition from './jobPosition'
import {apiUrl} from '../config'
    export default {
        data: () => ({
            API_URL: apiUrl,
            dialog:false,
            sheet:"",
                showProfilePage: false,
                drawer: false,
                showJobForm: false,
                items: [
                ],

                items2: [
                    { title: 'Nebucanazzar', icon: 'mdi-alien' },
                    { title: 'Sirius Technology', icon: 'mdi-space-station' },
                    { title: 'Sawlid ', icon: 'mdi-engine' },
                    { title: 'Fluid', icon: 'mdi-water-plus' },
                ],
                mini: true,
        }),  
        components: {
            profilePage,
            jobPosition
        },
        methods: {
            truncateDescription(description, limit) {
      if (description.length <= limit) {
        return description;
      }
      return description.substring(0, limit) + '...';
    },
            async getJobPositions() {
            try {
                // fetch profile
                let user = localStorage.getItem('user');
                user = JSON.parse(user);

                const authToken = 'Bearer ' + user['access'];

                console.log(authToken)

                const response = await axios.get(`${this.API_URL}job-positions/`, {
                headers: {
                    'Authorization': authToken,
                },
                })
                // set the data returned as profile
                console.log("business ideas ====>",response.data);
                this.items = response.data;
            
                
            } catch (error) {
                // log the error
                console.log(error);
            }
            },
            toggleProfilePage() {
                this.showProfilePage = !this.showProfilePage;
            },
            toggleJobForm() {
                // this.showJobForm = !this.showJobForm;
                this.dialog = !this.dialog;
            },
        },
        created () {
    
        this.getJobPositions();
        },
    }
</script>
<style>
.bottom-div {
    position: absolute;
    bottom: 0;
}
</style>
